import { MutableRefObject, RefCallback, useCallback, useEffect, useRef } from 'react';
import { useStickToBottom } from 'use-stick-to-bottom';

export const useChatAutoScroll = (
  onRepinToBottomRef?: MutableRefObject<(() => void) | undefined>
) => {
  const {
    scrollRef,
    contentRef,
    scrollToBottom: libraryScrollToBottom,
    isAtBottom
  } = useStickToBottom({
    resize: 'smooth',
    initial: 'auto'
  });

  const isPinnedToBottomRef = useRef(isAtBottom);
  const prevIsAtBottomRef = useRef(isAtBottom);

  isPinnedToBottomRef.current = isAtBottom;

  useEffect(() => {
    if (isAtBottom && !prevIsAtBottomRef.current) {
      onRepinToBottomRef?.current?.();
    }
    prevIsAtBottomRef.current = isAtBottom;
  }, [isAtBottom, onRepinToBottomRef]);

  const scrollToBottom = useCallback((behavior: ScrollBehavior = 'smooth') => {
    void libraryScrollToBottom({ animation: behavior });
  }, [libraryScrollToBottom]);

  return {
    messagesListRef: scrollRef as RefCallback<HTMLDivElement> & MutableRefObject<HTMLDivElement | null>,
    messagesContentRef: contentRef as RefCallback<HTMLDivElement> & MutableRefObject<HTMLDivElement | null>,
    scrollToBottom,
    isPinnedToBottom: isAtBottom,
    isPinnedToBottomRef
  };
};
